import React from 'react';
import { Navbar } from '../components/Navbar';
import { ArticlePage } from '../components/ArticlePage';
import { Footer } from '../components/Footer';
export const Article = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2333" data-mp="656y4l0eaxnt">
      <Navbar data-id="element-2334" data-mp="65yuhy1tgzf5" />
      <ArticlePage data-id="element-2335" data-mp="67jo9lgb4eby" />
      <Footer data-id="element-2336" data-mp="16vp2chxcr6n" />
    </div>;
};